<template>
    <header class="app_header">
						
        <div class="d-flex align-items-center mb-3" style="gap: .75rem;">
            <b-button class="transparent app_header_btn" @click="go_back">

                <base-icon name="arrow long_left" />

            </b-button>

            <h3>{{ group_node.data.full_name }}</h3>

            <b-nav pills class="ml-auto">
                <b-button class="transparent app_header_btn" @click="() => this.$emit('toggle_fullscreen')" id="tooltip-set_fullscreen">
                    <base-icon :name="!fullscreen ? 'Full - Short_open' : 'Full - Short_close'" />
                </b-button>

                <b-tooltip target="tooltip-set_fullscreen" triggers="hover" container="fullscreen">

                    {{ !fullscreen ? 'Развернуть на весь экран' : 'Свернуть' }}

                </b-tooltip>
            </b-nav>
        </div>

        <div class="d-flex justify-content-between">
            <b-tabs
                id="main_tree_groups"
                ref="main_tree_groups_tabs"
                v-model="main_tree_groups_type" 
                class="blue-500"
                >
                <!-- v-on:changed="tab_changed" -->
                <b-tab id="groups" title="Параметры группировки" @click="() => change_type('groups')"></b-tab>
                <b-tab id="encoding_rules" v-if="!group_node.children.length" title="Правила кодирования" @click="() => change_type('encoding_rules')"></b-tab>
                <b-tab id="objects" title="Объекты оценки" @click="() => change_type('objects')"></b-tab>
                <b-tab id="analogues" v-if="!group_node.data.not_editable" title="Объекты-аналоги" @click="() => change_type('analogues')">
                    <template #title>
                        <div class="d-flex" style="gap: .5rem;pointer-events: auto;">
                            <span>Объекты-аналоги</span>
							<analogues v-if="!group_node.data.parent_id && check_roles([ 'group_tree', 'grouping', 'model' ])" v-on:change_type="ev => change_type('analogues', ev, true)" />
                        </div>
                    </template>
                </b-tab>
                <b-tab id="cost_evaluations" v-if="!group_node.children.length" :disabled="!group_node.data.has_cost_evaluation && !is_individual" @click="() => change_type('cost_evaluations')">
                    <template #title>
                        <div class="d-flex" style="gap: .5rem;pointer-events: auto;">
                            <span>Модели оценки КС</span>
                            
                            <cost_evaluations :group_node="group_node" v-if="
                                    (!group_node.data.cost_evaluation_comparative_model_imported || group_node.data.not_editable)
                                    && ( 
                                        check_roles([ 'model' ]) && (!group_node.data.has_cost_evaluation || group_node.data.has_cost_evaluation_individual)
                                        || check_roles([ 'group_tree', 'cost' ])
                                    )
                                "
                            />
                        </div>
                    </template>
                </b-tab>
                <b-tab id="group_statistic" title="Статистика" @click="() => change_type('group_statistic')"></b-tab>
            </b-tabs>
        </div>

    </header>
</template>

<script>

import api from "../../api"
import main_tree from "../../api/main_tree"
import analogues from "./analogues"
import cost_evaluations from "./cost_evaluations"

export default
{
    props :
    {
        group_node: Object,
        fullscreen: Boolean
    },

    components :
    {
        analogues,
        cost_evaluations
    },

    data()
    {
        return {
			main_tree_groups_type : 0,
			tabs :
			{
				groups : 0,
				encoding_rules : null,
				objects : 1,
				analogues : 2,
				cost_evaluations : null,
				group_statistic : 3,
			},
        }
    },
    
    watch :
	{
		$route :
        {

            handler(to)
            {
                if(to && to.name)
                {
                    this.update_tabs(this.group_node)

                    var [ , path ] = to.path.split('/')
                    
                    this.set_type_by_path(path)
                }
            },
            immediate: true

        },

        group_node :
        {
            handler(newValue)
            {
                this.update_tabs(newValue)
            }
        }
	},

    computed :
    {
        is_individual()
        {
            const is_ce = this.$route.path.split('/')[1]
            return is_ce === 'cost_evaluations' && this.$route.params.type === 'individual'
        }
    },

    updated()
    {
        var [ , path ] = this.$route.path.split('/')
        this.set_type_by_path(path)
    },

    methods :
    {
        check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        go_back()
		{
			api.back.go(this)
		},

        set_type_by_path(path)
        {
            if (path == 'analoguesprofitable' || path == 'expensives')
            {
                this.main_tree_groups_type = this.tabs['analogues']
            }
            else
            {
                this.main_tree_groups_type = this.tabs[path]
            }
        },

        change_type(name, additional_query = null, refresh_main_tree = false)
		{
			if(refresh_main_tree)
				main_tree.create(this)

            this.$router.push(
                this.$root.$children[0].get_new_path(this.group_node, name, false, additional_query)
            )
                .catch((e) => {if (e.type != 2) console.error(e)})
		},

		update_tabs(node)
		{
            if (!node.data.not_editable)
			{
				if (node && node.children.length)
				{
					this.tabs.encoding_rules = null
					this.tabs.objects = 1
					this.tabs.analogues = 2
					this.tabs.cost_evaluations = null
					this.tabs.group_statistic = 3
				}
				else
				{
					this.tabs.encoding_rules = 1
					this.tabs.objects = 2
					this.tabs.analogues = 3
					this.tabs.cost_evaluations = 4
					this.tabs.group_statistic = 5
				}
			}
			else
			{
				this.tabs.analogues = null
				if (node && node.children.length)
				{
					this.tabs.encoding_rules = null
					this.tabs.objects = 1
					this.tabs.cost_evaluations = null
					this.tabs.group_statistic = 2
				}
				else
				{
					this.tabs.encoding_rules = 1
					this.tabs.objects = 2
					this.tabs.cost_evaluations = 3
					this.tabs.group_statistic = 4
				}
			}
		},

        // #############################################################################
        // API

        // select_group(node, type)
        // {
        //     console.log("select_group")
        //     this.update_tabs(node)
        //     this.main_tree_groups_type = this.tabs[type]
        // }
    }
}
</script>

<style>
.app_header
{
    border-bottom: 1px solid #DEE2E6;
    z-index: 3;
}

.app_header_btn svg
{
	vertical-align: unset;
}

.app_header_btn
{
	height: 1.5rem !important;
}
</style>
